// pwa-src/components/cards/playerCards/v2/PlayerCard.ts
import { Attribute, CalculatedPlayer, LookupDetails } from '@alienheadwars/football-card-manager-model'; // Added Attribute import
import React from 'react';
// import Avatar as MUIavatar from '@mui/material/Avatar';

//TODO move away from css files
import '@fontsource/norwester';
import { CardDimensions, SmallCard } from './CardDimensions';
import { ExpandablePlayerCard } from './ExpandablePlayerCard';

interface SelelectablePlayerCardComponentProps {
    key?: string;
    player: CalculatedPlayer | LookupDetails;
    dimensions?: CardDimensions;
    onClick?(): void
    actions?: React.ReactNode
    // margin?: boolean
    selected?: boolean //todo update box shadow to 0 if selected
    attributeSet?: Attribute[]
    allowExpandWhenNotSelected?:boolean
}



export const SelectablePlayerCard = (props: SelelectablePlayerCardComponentProps) => {

    const dimensions = props.dimensions ?? SmallCard
    const expandedDimensions: CardDimensions = {
        ...dimensions,
        borderWidth: `calc(${dimensions.cardWidth} * 0.1)`,
        cardWidth: `calc(  (${dimensions.cardWidth} * 0.9) + (${dimensions.playerStatFontSize} * 2) * 1.05)`,
        statsFrameWidth:  `calc( (${dimensions.cardWidth} * 0.9) + (${dimensions.playerStatFontSize} * 2) * 1.05)`,
        // statsFrameWidth: `calc(${dimensions.cardWidth} * 1.1)`,
        statsFrameMargin: '0px',
    }

    const key=props.key??props.player.id

    return <ExpandablePlayerCard {...props} key={key} dimensions={props.selected? expandedDimensions : dimensions} blockExpand={!props.selected && !props.allowExpandWhenNotSelected }/>

}